import { render, staticRenderFns } from "./TransactionAlert.vue?vue&type=template&id=81e1d026&"
import script from "./TransactionAlert.vue?vue&type=script&lang=js&"
export * from "./TransactionAlert.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports